.EventHoursInputOptions {
  &--active {
    border-left: 2px solid #000;
  }

  &__row {
    display: flex;
    margin-bottom: 10px;

    &:last-of-type {
      margin-bottom: 0;
    }

    > div {
      flex-grow: 1;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }

    label {
      margin-bottom: 0;
    }
  }
}
